import { memo, isValidElement, cloneElement } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Fade from '@mui/material/Fade'

import { AbsoluteCenter } from 'components/ui/Shared'

import { Wrapper } from './ButtonContent.styles'

import { ButtonContentProps } from './index'

function ButtonContent({
  isLoading,
  children,
  text,
  iconStart,
  iconEnd,
}: ButtonContentProps): JSX.Element {
  return (
    <>
      <Fade in={isLoading} unmountOnExit>
        <AbsoluteCenter>
          <CircularProgress
            size='1.5em'
            color='inherit'
            thickness={4}
            style={{ display: 'block' }}
          />
        </AbsoluteCenter>
      </Fade>
      <Wrapper $show={!isLoading}>
        {isValidElement(iconStart) &&
          cloneElement(iconStart, { ...iconStart.props, className: 'btn-icon-start' })}
        {text ?? children}
        {isValidElement(iconEnd) &&
          cloneElement(iconEnd, { ...iconEnd.props, className: 'btn-icon-end' })}
      </Wrapper>
    </>
  )
}

export default memo(ButtonContent)
